import { GREY_MID } from '@payaca/constants/colours';
import { getReadableTextColour } from '@payaca/utilities/colourUtilities';
import { FC, useMemo } from 'react';

const EPC_RATING_BADGE_COLOURS: Record<string, string> = {
  A: '#5AC487',
  B: '#54B263',
  C: '#9BCC5B',
  D: '#F8D748',
  E: '#F0AE71',
  F: '#E1863D',
  G: '#D63442',
};

export const EpcRatingBadge: FC<{
  rating: string | null | undefined;
  energyEfficiency?: number | null | undefined;
}> = (props) => {
  const { rating, energyEfficiency } = props;

  if (!rating) return null;
  const colour = EPC_RATING_BADGE_COLOURS[rating.toUpperCase()] ?? GREY_MID;
  const textColour = useMemo(() => getReadableTextColour(colour), [colour]);

  return (
    <div className="flex mt-2">
      <div
        data-testid="epc-rating-badge"
        className="h-12 w-12 flex justify-center items-center font-bold"
        style={{
          backgroundColor: colour,
          color: textColour,
        }}
      >
        {energyEfficiency && <>{energyEfficiency} </>} {rating}
      </div>
      <div
        className="border-t-[23px] w-0 h-0 border-b-[23px] border-t-transparent border-b-transparent"
        style={{
          borderLeft: `23px solid ${colour}`,
        }}
      />
    </div>
  );
};
